import { ItemStatus } from '../../../../enums/ItemStatus';
import { ItemType } from '../../../../enums/ItemType';
import { Metadata } from '../../../../types';
import { getItemStatusId, getItemType } from '../../../../utils';
import { GetPermissionFn } from '../types';

export const getBacktagWidgetPermission: GetPermissionFn = ({
  workspace,
  data
}) => {
  if (!data) return { canView: false, canEdit: false };
  const itemType = getItemType(data);
  if (itemType == ItemType.content) {
    const itemStatusId = getItemStatusId(data);
    if (
      (workspace?.setting?.props?.backtaggingWindowOpen === true &&
        (itemStatusId == ItemStatus.Complete ||
          itemStatusId >= ItemStatus.Published)) ||
      isStagedAudienceDataPopulated(data)
    ) {
      return { canView: true, canEdit: true };
    }
  }

  return { canView: false, canEdit: false };
};

const isStagedAudienceDataPopulated = (data: Partial<Metadata>) => {
  if (
    data?.props?.stagedRolePriority?.length ||
    data?.props?.stagedPriorityJourneyStep?.length ||
    data?.props?.stagedTopicCategory?.length ||
    data?.props?.stagedTaxonomyTag?.length
  ) {
    return true;
  } else {
    return false;
  }
};
